
//components
import Header from "./Header"
import Code from "./Code"
import Result from "./Result"

const Home = () => {
  return (
    <>
    <Header />
            <Code />
            <Result />
    </>
  )
}

export default Home
